import { IRequestService } from '..';
import { KeyvaultEntry } from '../../models';

export interface IKeyvaultService {
    getKeyvaultEntries(): angular.IPromise<KeyvaultEntry[]>;
}

export class KeyvaultService implements IKeyvaultService {
    static serviceId: string = 'keyvaultService';

    static $inject = ['requestService'];

    constructor(private _requestService: IRequestService) {}

    private getControllerUrl(): string {
        return this._requestService.getUrlV1() + 'keyvault';
    }

    getKeyvaultEntries(): angular.IPromise<KeyvaultEntry[]> {
        const url = this.getControllerUrl();
        return this._requestService.get(url);
    }
}
